import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { FormControl } from '@angular/forms';
import { Utils } from '../../../../../../utils/utils';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { OshProtocol } from 'src/app/interfaces/osh/oshProtocol';

@Component({
    selector: 'osh-assignwaveprotocol-popup',
    templateUrl: './assignwaveprotocol-popup.component.html',
    styleUrls: ['./assignwaveprotocol-popup.component.less',
        '../../../../../../style/new-generic-styles.component.less'],
    standalone: false
})
export class AssignWaveProtocolPopupComponent implements OnInit {

    public dataSource = new MatTableDataSource<any>();

    protocols: OshProtocol[] = []
    form = new FormControl();

    columnsToDisplay = ['selector', 'code', 'name'];
    expandedElements = new Set();

    selectedList: number[] = []
    selection = new SelectionModel<any>(true, []);

    constructor(
        private readonly http: HttpClient
        , public dialogRef: MatDialogRef<AssignWaveProtocolPopupComponent>
        , private readonly toastrService: ToastrService,
        @Inject('BASE_URL') private readonly baseUrl: string,
        @Inject(MAT_DIALOG_DATA) public data: any) { }

    ngOnInit(): void {
        this.getUnassignedProtocols()
    }

    getUnassignedProtocols() {
        Utils.httpGetUnassignedOshWaveProtocolConfigurations(
            this.http,
            this.baseUrl,
            this.data.waveId,
            this,
            function (tthis: AssignWaveProtocolPopupComponent, list: any) {
                console.log(list)
                tthis.protocols = list
                tthis.dataSource.data = list
            },
            null
        )
    }

    backButtonHandler(event: any) {
        event.preventDefault();
        this.dialogRef.close();
    }
    
    addButtonHandler() {
        if (this.form){
            if (this.form.invalid || this.selectedList.length == 0) {
                return;
            }
        }

        Utils.httpAssignOshWaveProtocolConfigurations(
            this.http
            , this.baseUrl
            , this.data.waveId
            , this.selectedList
            , this
            , function (tthis: AssignWaveProtocolPopupComponent, result: any) {
                tthis.dialogRef.close({ event: 'submit' });
                if (result) {
                    tthis.toastrService.success('Protocols were assigned successfully!');
                }
                else
                    tthis.toastrService.error('Protocols could not be assigned to the Wave. Please, contact with administrator');
            },
            null
        );
    }

    expandedItemSelected(id: number) {
        this.selection.select(id)
        this.onSelect(id);
    }

    expandedItemDeselected(id: number) {
        this.selection.deselect(id)
        this.onDeselect(id);
    }

    onSelect(selectedReleaseRow: number) {
        this.selectedList.push(selectedReleaseRow)
    }
    
    onDeselect(selectedReleaseRow: number) {
        const index = this.selectedList.indexOf(selectedReleaseRow);
        if (index !== -1) {
            this.selectedList.splice(index, 1);
        }
    }
    
    protocolItemsSelected(ischecked: boolean, row: any) {
        const id = row.id || row.protocolId;
        if (ischecked) {
            this.expandedItemSelected(id);
        } else {
            this.expandedItemDeselected(id);
        }
    }
}



